import { render, staticRenderFns } from "./ReportingUnitWorkflowTab.vue?vue&type=template&id=fd0933e2&scoped=true"
import script from "./ReportingUnitWorkflowTab.vue?vue&type=script&lang=js"
export * from "./ReportingUnitWorkflowTab.vue?vue&type=script&lang=js"
import style0 from "./ReportingUnitWorkflowTab.vue?vue&type=style&index=0&id=fd0933e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0933e2",
  null
  
)

export default component.exports